import React, { useState } from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { Table, Space, Tag, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { ExcelButtons } from '../../components/ExcelButtons';

interface LevelDto {
  id: string;
  levelNumber: number;
  title: string;
  translations?: Record<string, Record<string, string>> | null;
  requiredXp: number;
  rewardCoins: number;
  iconUrl?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

const tagStyle = (color: string) => ({
  borderColor: color,
  color,
  background: `${color}15`,
  borderRadius: 9999,
  padding: '2px 12px',
  fontWeight: 500,
});

export const LevelList: React.FC = () => {
  const [searchText, setSearchText] = useState('');

  const { tableProps } = useTable<LevelDto>({
    resource: 'levels',
    filters: {
      permanent: [{ field: 'search', operator: 'contains', value: searchText }],
    },
    pagination: { current: 1, pageSize: 20 },
    queryOptions: { keepPreviousData: true },
  });

  return (
    <List resource="levels">
      <div style={{ marginBottom: 16, display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <Input.Search
          prefix={<SearchOutlined />}
          placeholder="Search by title..."
          defaultValue={searchText}
          onSearch={(value) => setSearchText(value)}
          allowClear
          style={{ width: 320 }}
        />
        <ExcelButtons resource="admin/levels" />
      </div>
      <Table {...tableProps} rowKey="id" scroll={{ x: 1200 }}>
        <Table.Column dataIndex="levelNumber" title="Level #" />
        <Table.Column dataIndex="title" title="Title" />
        <Table.Column dataIndex="requiredXp" title="Required XP" />
        <Table.Column dataIndex="rewardCoins" title="Reward Coins" />
        <Table.Column
          dataIndex="isActive"
          title="Active"
          filters={[
            { text: 'Active', value: true },
            { text: 'Inactive', value: false },
          ]}
          onFilter={(value, record: any) => record.isActive === value}
          render={(isActive: boolean) => (
            <Tag style={tagStyle(isActive ? '#3ecf8e' : '#898989')}>
              {isActive ? 'Active' : 'Inactive'}
            </Tag>
          )}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_: any, record: LevelDto) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} resource="levels" />
              <ShowButton hideText size="small" recordItemId={record.id} resource="levels" />
              <DeleteButton hideText size="small" recordItemId={record.id} resource="levels" />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
